export default __webpack_public_path__ + "static/media/header.2447243c.png";